<template>
    <CustomHeader v-if="!isTabView" :text="$t('vip.title')" :showHistory="true" @openHistoryPopup="showHistory" />
    <div class="vip-container">
        <div class="subContainer" :style="{ padding: isTabView ? '0px 0px 25px' : '70px 0px 25px' }">
            <VipCardUI @claimVIP="VIPClaim" :remainRewards="dataSet.remainRewards" />
            <p class="table-title">{{ $t('vip.tireList') }}</p>
            <div>
                <div class="tabs" :class="{ 'tabs-top-zero': isTabView }">
                    <van-tabs id="vipTabs" :ellipsis="false" v-model:active="active">
                        <van-tab v-for="index in tabList" :title="$t(index.name)" :key="index.id" :name="index.id">
                        </van-tab>
                    </van-tabs>
                </div>

                <VIPTableView :activeNo="dataSet.active" :tableData="dataSet.tabelData" :isTabView="isTabView"
                    :activeData="dataSet.vipConfigData?.rewardsStatus" :vipRewardInfo="dataSet.VIPRewardsInfo"
                    :nextLevelRecord="dataSet.nextLevelRecord" :nextLevel="dataSet.nextLevel" />
            </div>
            <div class="bottom_text">
                <van-row>
                    <van-col span="24" class="title">
                        <div>{{ $t('vip.vipActivityInstructions') }}</div>
                    </van-col>
                </van-row>
                <div class="line_text" v-for="(item, index) in dataSet.activity_intro" :key="index" v-html="item">
                </div>
            </div>
        </div>
    </div>
    <VipHistoryPopup ref="historyRef" />
</template>
<script setup lang="ts">
import CustomHeader from '@/themes/themeFour/components/common/customHeader.vue';
import VIPTableView from './vipTableView.vue';
import { computed, ref, watch } from 'vue';
import VipHistoryPopup from './vipHistoryPopup.vue';
import { VipData } from '@/view/vip/supportScript';
import { TAB_LIST_THREE } from '@/view/vip/supportScript';
import VipCardUI from './vipCardUI.vue';

const progressPercentage = computed(() => 6500 * 100 / 10000);
const active = ref(0);
const historyRef = ref()
const vipConfigData = ref()
const tabList = computed(() => {
    var TabList = [...TAB_LIST_THREE]
    if (props.dataSet.vipConfigData?.rewardsStatus.isDailyReward !== 1) {
        TabList = TAB_LIST_THREE.filter(item => item.id !== 2)
    }
    if (props.dataSet.vipConfigData?.rewardsStatus.isWeeklyRewards !== 1) {
        TabList = TabList.filter(item => item.id !== 3)
    }
    if (props.dataSet.vipConfigData?.rewardsStatus.isMonthlyRewards !== 1) {
        TabList = TabList.filter(item => item.id !== 4)
    }
    return TabList
});
const showHistory = () => {
    historyRef.value.open()
}
const props = defineProps<{
    dataSet: VipData,
    isTabView?: boolean
}>()
const emit = defineEmits(['vIPClaim', 'update:active'])

const VIPClaim = () => {
    emit('vIPClaim')
}
watch(active, (val) => {
    emit('update:active', val)
})

</script>
<style scoped>
.vip-container {
    /* min-height: 100vh; */
    /* background: #003534; */
}

.vip-banner {
    position: relative;
}

.vip-banner img {
    width: 100%;
}

.header-text {
    position: absolute;
    top: 45%;
    height: 30%;
    left: 0;
    right: 0;
    color: #FFF;
    font-size: 45px;
    font-weight: bold;
    text-shadow: 0 2px 0 #232833;
    text-align: center;
    align-items: center;
    display: flex;
    justify-content: center;
}

.topCard {
    position: relative;
}

.topCard img {
    margin-top: 15px;
    width: 60px;

}

.topText {
    position: absolute;
    background: #fe5353;
    padding: 2px;
    border-radius: 5px;
    bottom: 82%;
    color: #fff;

}

.table-title {
    color: #fff;
    font-size: 18px;
    padding-left: 15px;
}

/* .subContainer {
    padding: 70px 25px 25px;
} */

.middle-banner {
    border-radius: 10px;
    white-space: nowrap;
}

.toData {
    background: #191e2d;
    padding: 10px 2px 10px 0px;
    border-radius: 10px;
}

.middle-text-container {
    justify-content: center;
    display: flex;
    flex-direction: column;
}

.middle-header-text {
    color: #757881;
    font-size: 15px;
    text-align: left;
    /* padding: 5px 15px; */
}

@media (max-width:450px) {
    .middle-header-text {
        font-size: 13px;
    }

    .right-btn {
        font-size: 11px;
    }

    /* .middle-amount {
        font-size: 30px;
    } */
}

.middle-amount {
    color: #FFEE00;
    font-size: 40px;
    text-align: left;
    font-weight: bold;
    padding: 5px 15px 25px;
}

.claimBtn {
    font-size: 15px;
    background: #fd66b1;
    color: #fff;
    border: .02667rem solid #fd66b1;
    border-radius: 10px;
    padding: 15px 0;
    display: flex;
    align-items: center;
    display: flex;
    text-align: center;
    justify-content: center;
    width: 95%;
    /* font-weight: bold; */
}

.disableBtn {
    background: #2e2759;
    color: #7758a4;
    border: .02667rem solid #493779;
}

.bottomData {
    background-image: linear-gradient(270deg, #211a62, #322145);
    padding: 10px;
    border-radius: 0 0 10px 10px;
}

.bottomData-text {
    font-size: 13px;
    color: #e695e6;
    padding-left: 15px;
}

.right-btn {
    width: 66%;
    border: none;
    color: #fff;
}

.progressCard {
    position: relative;
    margin-top: 10px;
    background: #3e2e4b;
    border-radius: 10px;
    /* border: 2px solid orange; */
    border-left: none;
    border-right: none;
    padding: 15px;
}

.card-top {
    color: #FFCEF4;
    font-size: 13px;
    text-align: center;
    white-space: nowrap;
}

.card-top-right {
    color: #ffcef4;
    font-size: 18px;
    text-align: right;
    white-space: nowrap;
}

.bar {
    position: relative;
    background: rgba(255, 255, 255, 0.25);
    border-radius: 10px;
    height: 8px;
    width: 100%;
    margin: 10px 0;
}

.progress {
    background: #ffa600;
    border-radius: 10px;
    height: 8px;
}

.progress-end-dot {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: 8px;
    height: 8px;
    background-color: white;
    border-radius: 50%;
    z-index: 2;
}

.cur-frame {
    height: 0.62rem;
    background: #DD7A33;
    border-radius: 0.34rem;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin: 5px 0;
}

.card-top-bottom {
    color: #F8E400;
    font-size: 12px;
    text-align: center;
    white-space: nowrap;
}

.card-top-bottom-right {
    color: #ffffffd9;
    font-size: 12px;
    text-align: right;
    white-space: nowrap;
}

.bettingVolume {
    padding: 10px;
    border-radius: 15px;
    margin-top: 10px;
}

.tabs {
    margin-top: -10px;
    position: sticky;
    top: 55px;
    z-index: 10;
    background: #002121;
    padding: 10px 0px 0px;
    border-bottom: 0.5px solid #0db0ad71;
}
.tabs-top-zero {
    top: 0 !important;
}
.activity-text {
    color: #f9c48680;
    text-align: left;
    white-space: pre-wrap;
    font-size: 14px;
    padding-bottom: 20px;
}

.activity-title-row {
    display: flex;
    align-items: center;
    margin: 30px 0px 20px;
}

.left-img {
    background-image: linear-gradient(90deg, rgba(249, 196, 134, 0.00) 0%, rgba(249, 196, 134, 0.50) 100%);
    border-radius: 1px;
    width: 5rem;
    height: 2px;
    margin-right: 0.2rem;
}

.activity-title {
    color: #f9c48680;
    font-size: 15px;
    display: flex;
    justify-content: center
}

.right-img {
    transform: scaleX(-1);
    background-image: linear-gradient(90deg, rgba(249, 196, 134, 0.00) 0%, rgba(249, 196, 134, 0.50) 100%);
    border-radius: 1px;
    width: 5rem;
    height: 2px;
    margin-left: 0.2rem;
}

.bottom_text {
    padding: 30px 15px 0;
}

.title {
    color: #fff;
    font-weight: bold;
    font-size: 18px;
    padding: 10px 0;
}

.line_text {
    color: rgba(255, 255, 255, 0.4);
    font-size: 15px;
    padding: 5px;
}




.cur-frame-point {
    width: 0.62rem;
    height: 0.62rem;
    background: #FFFFFF;
    border-radius: 0.34rem;
}

::v-deep #vipTabs .van-tabs__nav {
    overflow-x: auto !important;
    white-space: nowrap !important;
    font-size: 15px;
    font-weight: 500;
}

::v-deep #vipTabs .van-tab__text {
    white-space: nowrap !important;
    overflow: visible !important;
    text-overflow: unset !important;

}

::v-deep #vipTabs {
    --van-tabs-nav-background: transparent !important;

}

::v-deep #vipTabs .van-tab--active {
    position: relative;
    --van-tab-active-text-color: #0db0ae !important;
    background: #024a49;
    border-radius: 5px;
}

::v-deep #vipTabs .van-tab--active::after {
    content: "";
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 3px;
    background: #0db0ae;
}

::v-deep #vipTabs .van-tab {
    --van-tab-text-color: rgba(255, 255, 255, 0.4) !important;
    /* font-weight: bold; */
    padding-right: 20px;
}

::v-deep #vipTabs .van-tabs__line {
    display: none;
}

@media (max-width: 450px) {
    .title {
        font-size: 16px;
    }

    .line_text {
        font-size: 14px;
    }
}
</style>